import * as React from 'react';

import { ApiWrapper, MSGroupEntity, MSTenantEntity } from 'jamespot-user-api';
import { JDriveApi } from 'jamespot-user-api/lib/src/apis/drive/drive';
import { useAbortController } from '../../hooks/useAbortController';

type ErrorType = {
    error: number;
    errorMsg: string;
    messages: {
        code: number;
        msg: string;
    }[];
};

/**
 * This is only used inside App365. if you need to use it outside of this component, consider making it a slice
 */
export function useTenants({ handlers, id }: { handlers: { drive: Pick<JDriveApi, 'tenants'> }; id: string }) {
    const abortController = useAbortController();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<ErrorType | undefined>(undefined);
    const [entities, setEntities] = React.useState<MSTenantEntity[]>([]);

    React.useEffect(() => {
        setLoading(true);
        handlers.drive
            .tenants({ id }, { signal: abortController.signal })
            .then((resp) => {
                setEntities(resp.result);
                setLoading(false);
            })
            .catch((error) => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                    setError(error);
                }
            });
    }, [abortController.signal, handlers.drive, id]);

    return { loading, entities, error };
}

/**
 * This is only used inside App365. if you need to use it outside of this component, consider making it a slice
 */
export function useGroups({
    request,
}: {
    request: (query?: string, filter?: string) => Promise<ApiWrapper<MSGroupEntity[]>>;
}) {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<ErrorType | undefined>(undefined);
    const [entities, setEntities] = React.useState<MSGroupEntity[]>([]);

    React.useEffect(() => {
        setLoading(true);
        request()
            .then((resp) => {
                setEntities(resp.result);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setError(error);
            });
    }, [request]);

    return { loading, entities, error };
}
